import { Menu, useSidebarState } from "react-admin";
import { ResourceMenuItems } from "../utils/resourceMenuItems";
import {
  Clear,
  FirstPage,
  HomeOutlined,
  LastPage,
  Search,
} from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";
import { MenuFavorites } from "./menuFavorites";
import { WithRoles } from "../acl/withRoles";
import { useMyContext } from "./myContext";

const MenuSearch = ({ filter, setFilter }) => (
  <WithRoles can={["superuser"]}>
    <TextField
      className="MenuSearch"
      variant="outlined"
      placeholder="Menu search"
      value={filter}
      onChange={(event) => {
        setFilter(event.target.value);
      }}
      onKeyDown={(e) => e.stopPropagation()}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {filter ? (
              <Clear
                onClick={() => setFilter("")}
                style={{ cursor: "pointer" }}
              />
            ) : (
              <Search color="disabled" />
            )}
          </InputAdornment>
        ),
      }}
    />
  </WithRoles>
);

const CustomToggleSidebarButton = (props) => {
  const [open, setOpen] = useSidebarState();
  const paddingY = "10px !important";

  return (
    <IconButton
      sx={{
        paddingTop: paddingY,
        paddingBottom: paddingY,
        alignSelf: "flex-end",
      }}
      color="inherit"
      onClick={() => setOpen(!open)}
      aria-label={open ? "Close menu" : "Open menu"}
      {...props}
    >
      {open ? <FirstPage /> : <LastPage />}
    </IconButton>
  );
};

export const MyMenu = ({ children }) => {
  const [filter, setFilter] = useState("");
  const { acp } = useMyContext();

  return (
    <Menu>
      <CustomToggleSidebarButton className="MuiListItemIcon-root" />
      <MenuSearch filter={filter} setFilter={setFilter} />
      <MenuFavorites>
        <hr style={{ borderColor: "grey", margin: "10px 21px" }} />
      </MenuFavorites>
      <Menu.DashboardItem primaryText="Home" leftIcon={<HomeOutlined />} />
      <ResourceMenuItems
        filter={filter}
        noFavorites={!acp.hasRoles(["superuser"])}
      />
      <hr style={{ borderColor: "grey", margin: "10px 21px" }} />
      {children}
    </Menu>
  );
};
